document.addEventListener("DOMContentLoaded", () => {
  const homeBg = document.querySelector(".home-bg");
  if (!homeBg) return;

  const slides = gsap.utils.toArray(".slider-wrapper .slide", homeBg);
  const logoBg = document.querySelector(".bg-logo img");

  let current = 0;
  //let loopCall = null;
  let isTransitioning = false;

  //Apparition textes Intro
  document
    .querySelectorAll(".home-context h1, .home-context h2, .home-context h3")
    .forEach((el) => {
      const span = document.createElement("span");
      span.innerHTML = el.innerHTML;
      el.textContent = "";
      el.appendChild(span);
    });

  gsap.set(
    ".home-context h1 span, .home-context h2 span, .home-context h3 span",
    { y: 40, opacity: 0 }
  );

  gsap.to(
    ".home-context h1 span, .home-context h2 span, .home-context h3 span",
    {
      y: 0,
      opacity: 1,
      duration: 1.2,
      ease: "power3.out",
      stagger: 0.15,
      delay: 0.4,
    }
  );

  //Init des colors pour le bg des slides
  const slideStyles = {
    mrs: {
      bg: "#312821",
      svg: "brightness(0) saturate(100%) invert(95%) sepia(5%) saturate(1852%) hue-rotate(335deg) brightness(88%) contrast(89%)",
    },
    okali: {
      bg: "#797E2E",
      svg: "brightness(0) saturate(100%) invert(19%) sepia(12%) saturate(2272%) hue-rotate(351deg) brightness(96%) contrast(90%)",
    },
    lcu: {
      bg: "#413C38",
      svg: "brightness(0) saturate(100%) invert(81%) sepia(77%) saturate(977%) hue-rotate(315deg) brightness(88%) contrast(83%)",
    },
    album: {
      bg: "#302A2F",
      svg: "brightness(0) saturate(100%) invert(46%) sepia(86%) saturate(304%) hue-rotate(326deg) brightness(89%) contrast(89%)",
    },
  };

  function applyBackground(slide) {
    const key = Object.keys(slideStyles).find((cls) =>
      slide.classList.contains(cls)
    );
    if (!key) return;

    const style = slideStyles[key];

    gsap.to(homeBg, {
      backgroundColor: style.bg,
      duration: 1,
      ease: "power2.out",
      overwrite: "auto",
    });

    if (logoBg) {
      gsap.to(logoBg, {
        filter: style.svg,
        duration: 1,
        ease: "power2.out",
        overwrite: "auto",
      });
    }
  }

  //Sliders + helpers
  function setSlideState(index, visible, z = 0) {
    gsap.set(slides[index], {
      autoAlpha: visible ? 1 : 0,
      zIndex: z,
      pointerEvents: visible ? "auto" : "none",
    });
  }

  function resetAllSlides() {
    slides.forEach((_, i) => setSlideState(i, false, 0));
  }

  //Transition
  function transitionTo(next) {
    if (isTransitioning || next === current) return;
    isTransitioning = true;

    const currentSlide = slides[current];
    const nextSlide = slides[next];

    const currentImg = currentSlide.querySelector("img");
    const nextImg = nextSlide.querySelector("img");

    resetAllSlides();
    setSlideState(current, true, 1);
    setSlideState(next, true, 2);

    if (nextImg) gsap.set(nextImg, { scale: 1.03, force3D: true });
    if (currentImg) gsap.set(currentImg, { force3D: true });

    const tl = gsap.timeline({
      defaults: { ease: "power2.out" },
      onComplete: () => {
        resetAllSlides();
        setSlideState(next, true, 1);
        current = next;
        isTransitioning = false;
      },
    });

    tl.to(currentSlide, { autoAlpha: 0, duration: 1 }, 0);

    if (nextImg) {
      tl.to(nextImg, { scale: 1, duration: 5.5, ease: "power3.out" }, 0);
    }

    applyBackground(nextSlide);
  }

  //Loop gsap
  function scheduleNext() {
    loopCall = gsap.delayedCall(7, () => {
      transitionTo((current + 1) % slides.length);
      scheduleNext();
    });
  }

  //Init de la boucle
  function start() {
    const reduceMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    slides.forEach((slide) => {
      const img = slide.querySelector("img");
      if (img) gsap.set(img, { scale: 1.03, force3D: true });
      gsap.set(slide, { autoAlpha: 0, zIndex: 0 });
    });

    homeBg.classList.add("is-ready");

    setSlideState(0, true, 1);
    applyBackground(slides[0]);

    const firstImg = slides[0].querySelector("img");
    if (firstImg && !reduceMotion) {
      gsap.to(firstImg, {
        scale: 1,
        duration: 10.5,
        ease: "power3.out",
      });
    }

    if (!reduceMotion) scheduleNext();
  }

  start();
});
